import {
  TransactionSearchOperation,
  TransactionSearchRequest,
} from '../../types';

export async function searchTransaction(
  request: TransactionSearchRequest,
  captchaToken: string
): Promise<TransactionSearchOperation> {

  if (!captchaToken) {
    throw new Error("Error solving captcha token for request");
  }

  const config: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Recaptcha-Token': captchaToken,
    }
  };

  let requestUrl;

  let flag = Boolean(false);

  if(request.identifier !== null && request.identifier !== undefined && request.identifier !== '') {
    flag = true;
    requestUrl = `/api/v1/transactions/${request.identifier}`;
  }

  else if ((request.currency!=null && request.amount != null && request.email != null && request.transactionDate != null && request.paymentMethod != null)
  && !flag){
    flag = true;
    const params = new URLSearchParams({ date: request.transactionDate,
      amount: request.amount.replace(/\./g, '').replace(',', '.'),
      currency: request.currency,
      paymentMethodType: request.paymentMethod.toString(),
      email: request.email});
    requestUrl = `/api/v1/transactions/params?${params.toString()}`;
  }
  else{
    throw new Error("Invalid request parameters");
  }


  const response = await fetch(requestUrl, config);

  const data = await response.json();

  const searchResultComplete = {
    transactionSearchRequest: request,
    transactionSearcherData: data
  }

  if (!response.ok || !flag) {
    throw new Error(data);
  }
  return searchResultComplete;
}
